import { html } from 'lit';

export default html`
  <svg width="20" height="14" viewBox="0 0 20 14" fill="#8552F6" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 0H0V14H20V0ZM2.5 4H3.25H5C6.09375 4 7 4.90625 7 6C7 7.125 6.09375 8 5 8H4V9.25V10H2.5V9.25V7.25V4.75V4ZM4 6.5H5C5.25 6.5 5.5 6.28125 5.5 6C5.5 5.75 5.25 5.5 5 5.5H4V6.5ZM12.5 6.75C12.5 5.25 13.7188 4 15.25 4C16.75 4 18 5.25 18 6.75V7.25C18 8.78125 16.75 10 15.25 10C13.7188 10 12.5 8.78125 12.5 7.25V6.75ZM15.25 5.5C14.5312 5.5 14 6.0625 14 6.75V7.25C14 7.96875 14.5312 8.5 15.25 8.5C15.9375 8.5 16.5 7.96875 16.5 7.25V6.75C16.5 6.0625 15.9375 5.5 15.25 5.5ZM8.25 4H10C11.0938 4 12 4.90625 12 6C12 6.6875 11.6562 7.3125 11.125 7.65625L11.875 8.875L12.5938 10H10.8125L10.5938 9.65625L9.5625 8H9V9.25V10H7.5V9.25V7.25V4.75V4H8.25ZM10 6.5C10.25 6.5 10.5 6.28125 10.5 6C10.5 5.75 10.25 5.5 10 5.5H9V6.5H10Z"
      fill="currentColor"
    />
  </svg>
`;
